/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./potato.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./potato.component";
var styles_PotatoComponent = [i0.styles];
var RenderType_PotatoComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_PotatoComponent, data: {} });
export { RenderType_PotatoComponent as RenderType_PotatoComponent };
export function View_PotatoComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.potato.name; _ck(_v, 1, 0, currVal_0); }); }
export function View_PotatoComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-potato", [], null, null, null, View_PotatoComponent_0, RenderType_PotatoComponent)), i1.ɵdid(1, 114688, null, 0, i2.PotatoComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var PotatoComponentNgFactory = i1.ɵccf("app-potato", i2.PotatoComponent, View_PotatoComponent_Host_0, { potato: "potato" }, {}, []);
export { PotatoComponentNgFactory as PotatoComponentNgFactory };
